        let reviews = [];
        let currentReviewIdx = 0;
        
        function collectReviews() {
          reviews = [];
          document.querySelectorAll('.review-card:not([style*="display: none"])').forEach(card => {
            reviews.push({
              img: card.querySelector('.review-img').src,
              name: card.querySelector('.review-name').innerText,
              stars: card.querySelector('.review-stars').innerText,
              date: card.querySelector('.review-date').innerText,
              comment: card.querySelector('.review-text').innerText
            });
          });
        }
        
        function openReviewModalByIdx(idx) {
          if (!reviews[idx]) return;
          currentReviewIdx = idx;
          const review = reviews[idx];
          document.getElementById('modalImg').src = review.img;
          document.getElementById('modalImg').alt = review.name + ' Bewertung';
          document.getElementById('modalName').innerText = review.name;
          document.getElementById('modalRating').innerText = review.stars;
          document.getElementById('modalDate').innerText = review.date;
          document.getElementById('modalComment').innerText = review.comment;
          document.getElementById('reviewModal').style.display = 'flex';
          document.body.style.overflow = 'hidden';
        }
        
        function openReviewModal(img, name, stars, date, comment) {
          document.getElementById('modalImg').src = img;
          document.getElementById('modalImg').alt = name + ' Bewertung';
          document.getElementById('modalName').innerText = name;
          document.getElementById('modalRating').innerText = stars;
          document.getElementById('modalDate').innerText = date;
          document.getElementById('modalComment').innerText = comment;
          document.getElementById('reviewModal').style.display = 'flex';
          document.body.style.overflow = 'hidden';
        }
        
        function prevReview() {
          if (reviews.length === 0) return;
          let prevIdx = currentReviewIdx - 1;
          if (prevIdx < 0) prevIdx = reviews.length - 1;
          openReviewModalByIdx(prevIdx);
        }
        function nextReview() {
          if (reviews.length === 0) return;
          let nextIdx = currentReviewIdx + 1;
          if (nextIdx >= reviews.length) nextIdx = 0;
          openReviewModalByIdx(nextIdx);
        }
        function closeReviewModal() {
          document.getElementById('reviewModal').style.display = 'none';
          document.body.style.overflow = '';
        }
        
        document.addEventListener('DOMContentLoaded', function() {
          collectReviews();
          document.querySelectorAll('.review-card:not([style*="display: none"])').forEach(function(card, idx){
            card.addEventListener('click', function(){
              openReviewModalByIdx(idx);
            });
          });
          const btn = document.getElementById("seeMoreBtn");
          if (btn) {
            btn.addEventListener("click", function() {
              document.querySelectorAll(".extra-review").forEach(card => {
                card.style.display = "inline-block";
              });
              btn.style.display = "none";
              setTimeout(() => {
                collectReviews();
                document.querySelectorAll('.review-card').forEach(function(card, idx){
                  card.onclick = function(){ openReviewModalByIdx(idx); };
                });
              }, 100);
            });
          }
          window.addEventListener('keydown', function(e) {
            if (e.key === "Escape") closeReviewModal();
            if (document.getElementById('reviewModal').style.display === 'flex') {
              if (e.key === "ArrowLeft") prevReview();
              if (e.key === "ArrowRight") nextReview();
            }
          });
          document.getElementById('reviewModal').addEventListener('click', function(e){
            if(e.target === this) closeReviewModal();
          });
        });